import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Role } from '../types/auth';

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles?: Role[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, allowedRoles }) => {
  const { isAuthenticated, isLoading, user } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-veraz-gold"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  if (allowedRoles && user && !allowedRoles.includes(user.role)) {
    // User is authenticated but doesn't have permission
    // Redirect to dashboard or show unauthorized message
    // For now, redirect to the admin home if they are not already there
    if (location.pathname !== '/admin' && location.pathname !== '/admin/dashboard') {
      return <Navigate to="/admin" replace />;
    }
    // If they are at dashboard and still not allowed (unlikely given dashboard is usually open), show message
    return <div className="p-8 text-center text-red-600">Acesso não autorizado.</div>;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
